import React, { useState, useEffect } from 'react';
import { useAuth } from '../../firebase/authContext';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { FiMessageCircle } from 'react-icons/fi';

const ChatButton = ({ onOpenChat }) => {
  const { currentUser } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    // Listen for chats with unread messages
    const unreadQuery = query(
      collection(db, "chats"),
      where("participants", "array-contains", currentUser.uid)
    );

    const unsubscribe = onSnapshot(unreadQuery, (snapshot) => {
      let count = 0;
      snapshot.forEach(doc => {
        const data = doc.data();
        if (data.lastMessage?.senderId !== currentUser.uid && !data.lastMessage?.isRead) {
          count++;
        }
      });
      setUnreadCount(count);
    });

    return unsubscribe;
  }, [currentUser]);

  return (
    <div className="relative">
      <button
        onClick={onOpenChat}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative p-2.5 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full hover:shadow-lg transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300"
        title="Chat with Dancers"
      >
        <FiMessageCircle className="w-5 h-5" />
        
        {unreadCount > 0 && (
          <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[18px] h-[18px] flex items-center justify-center font-bold animate-pulse border-2 border-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </div>
        )}
      </button>

      {isHovered && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black/90 text-white text-xs rounded-lg px-3 py-2 whitespace-nowrap z-50 backdrop-blur-sm shadow-lg">
          Messages
          {unreadCount > 0 && (
            <span className="ml-1 text-red-300">
              ({unreadCount} new)
            </span>
          )}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black/90"></div>
        </div>
      )}
    </div>
  );
};

export default ChatButton;
